import { ICellRendererParams } from '@ag-grid-community/core'

const LogFileCellRenderer = ({ params }: { params: ICellRendererParams }) => {
  const fileName = params.value?.split('/').pop()

  if (!fileName) {
    return <>-</>
  }

  return (
    <a download href={params.value} className="hover:underline">
      {fileName}
    </a>
  )
}

export default LogFileCellRenderer
